export default "__VITE_ASSET__frNMZo7Z__"